import './App.css';
import { Navigate } from 'react-router';

function App() {
  return <Navigate to="/login" />;
}

export default App;
